module.exports = __webpack_public_path__ + "img/fd0a48a.jpg";